import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
@Injectable({
  providedIn: "root",
})
export class AuthTokenInterceptors implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Login requests must not inherit a bearer token from an old session.
    if (req.url.includes("/api/account/login")) {
      return next.handle(req);
    }

    const access_token = localStorage.getItem("access_token");
    if (!access_token) {
      return next.handle(req);
    }
    const transformedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${access_token}`,
      },
    });
    return next.handle(transformedReq);
  }
}
